import React from 'react';
import PropTypes from 'prop-types';
import { Circle, StyledOption } from './StyledComponents';

export const Option = props => {
  const {
    children,
    className,
    cx,
    getStyles,
    isDisabled,
    isFocused,
    isSelected,
    innerRef,
    innerProps,
    data,
  } = props;

  return (
    <div
      style={{ ...getStyles('option', props), overflow: 'hidden' }}
      className={cx(
        {
          option: true,
          'option--is-disabled': isDisabled,
          'option--is-focused': isFocused,
          'option--is-selected': isSelected,
        },
        className,
      )}
      ref={innerRef}
      {...innerProps}
    >
      <Circle color={data.color} isSettings={data.isSettings} />
      <StyledOption title={children}>{children}</StyledOption>
    </div>
  );
};

Option.propTypes = {
  children: PropTypes.string,
  className: PropTypes.string,
  cx: PropTypes.func,
  getStyles: PropTypes.func,
  isDisabled: PropTypes.bool,
  isFocused: PropTypes.bool,
  isSelected: PropTypes.bool,
  innerRef: PropTypes.any,
  innerProps: PropTypes.any,
  data: PropTypes.any,
};
